import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmDialogComponent } from '@cumlaude/shared-components-dialogs';

@Component({
	selector: 'app-confirm-leave-dialog',
	templateUrl: './confirm-leave-dialog.component.html',
	styleUrls: ['./confirm-leave-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ConfirmDialogComponent],
})
export class ConfirmLeaveDialogComponent {}
